import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import OffBatchList from "../../components/400/offBatchList";
import Row from "../../components/400/row";
import BatchManagement from "../../components/400/BatchManagement";
import SectionDisplay from "../../components/400/displaySection";
import GroupDisplay from "../../components/400/displayGroup";
import SettingIcon from "@mui/icons-material/Settings";
import { NavLink, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";
import DisplaySemester from "./displaySemester";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Display() {
  const [dialog, setDialog] = useState(false);
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClick = () => {
    navigate("/batch_management/constants");
  };

  const handleClose = () => {
    setDialog(false);
  };

  return (
    <div>
      <Box sx={{ width: "100%", mt: 1 }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            display: "flex",
            justifyContent: "space-between",
            mb: -2,
            ml: 2,
            mr: 2,
          }}
        >
          <Tabs
            value={value} 
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="batch list" {...a11yProps(0)} />
            <Tab label="section list" {...a11yProps(1)} />
            <Tab label="group list" {...a11yProps(2)} />
            <Tab label="off batch list" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <BatchManagement />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <SectionDisplay />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <GroupDisplay />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <OffBatchList />
        </TabPanel>
      </Box>
    </div>
  );
}
